import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { merge, Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl implements OnDestroy {

  private readonly destroy$ = new Subject<void>();

  constructor(private translate: TranslateService) {
    super();
    merge(
      this.translate.onLangChange,
      this.translate.onTranslationChange,
      this.translate.onDefaultLangChange,
    )
      .pipe(startWith(null), takeUntil(this.destroy$))
      .subscribe(() => {
        this.translateLabels();
        this.changes.next();
      });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0) {
      return this.translate.instant('common.paginator.emptyRange', { length });
    }
    const effectiveLength = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < effectiveLength
      ? Math.min(startIndex + pageSize, effectiveLength)
      : startIndex + pageSize;
    return this.translate.instant('common.paginator.rangeLabel', {
      start: startIndex + 1,
      end: endIndex,
      length: effectiveLength,
    });
  };

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private translateLabels(): void {
    this.itemsPerPageLabel = this.translate.instant('common.paginator.itemsPerPage');
    this.nextPageLabel = this.translate.instant('common.paginator.nextPage');
    this.previousPageLabel = this.translate.instant('common.paginator.previousPage');
    this.firstPageLabel = this.translate.instant('common.paginator.firstPage');
    this.lastPageLabel = this.translate.instant('common.paginator.lastPage');
  }
}
